module.exports = __webpack_public_path__ + "static/media/wutiko-logo-black-yellow.0ce1b330.png";